/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/CreditCard';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const CreditCardIcon = withMuiAdapter(Base, 'CreditCard');
